import React, { useState } from "react";
import { WarningModal } from "../WarningModal";
import { useTranslation } from "react-i18next";
import { useDrawersContext } from "../../routes/tasks/drawers-context";
import { AtiraToast } from "../../utils/AtiraToast";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { taskActions } from "../../redux/task/task.slice";
import { userSliceSelectors } from "../../redux/user/user.selector";
import { taskSliceSelectors } from "../../redux/task/task.selector";
import { useFormContext } from "react-hook-form";
import { GetTasksFilterDto } from "../../model/task/dto/GetTasksFilterDto";
import fetchAfterTaskAction from "./functions/fetchAfterTaskAction";
import { appSliceSelectors } from "../../redux/app/app.selector";
import { useLocation } from "react-router-dom";
import { TestIDs } from "../../tests/types/testIds";

export const TaskDeleteModal: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { getValues: contextGetValues } = useFormContext<GetTasksFilterDto>();
  const {
    task,
    setTask,
    setEntry,
    kanbanCard,
    setKanbanCard,
    taskDeleteVisible,
    setTaskDeleteVisible,
  } = useDrawersContext();

  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;
  const tasksPage = useAppSelector(taskSliceSelectors.selectTasksPage);
  const tasksPageSize = useAppSelector(taskSliceSelectors.selectTasksPageSize);
  const searchOptions = useAppSelector(appSliceSelectors.selectSearchOptions);
  const floatingTodayTasksVisible = useAppSelector(
    appSliceSelectors.floatingTodayTasksVisible,
  );

  const deleteTask = async () => {
    try {
      setLoading(true);

      await dispatch(
        taskActions.deleteTask({
          userId,
          taskId: task?._id!,
          kind: task?.kind!,
        }),
      ).unwrap();

      await fetchAfterTaskAction({
        userId,
        task,
        entryId: task?.parentId!,
        taskId: task?._id,
        kanbanCardId: kanbanCard?._id,
        pathname,
        tasksPage,
        tasksPageSize,
        dispatch,
        setEntry,
        setTask,
        setKanbanCard,
        contextGetValues,
        searchKeyword: searchOptions?.keyword,
        isFloatingTodayTasksOpen: floatingTodayTasksVisible === true,
      });

      setTaskDeleteVisible(false);

      AtiraToast.success(t("tasks.delete.success"));
    } catch (e: any) {
      AtiraToast.apiError(e);
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  if (!task) {
    return null;
  }

  return (
    <WarningModal
      isOpen={taskDeleteVisible}
      loading={loading}
      onConfirm={deleteTask}
      onClose={() => setTaskDeleteVisible(false)}
      title={t("tasks.delete.warning.title", {
        task_name: task?.name,
      })}
      description={t("tasks.delete.warning.description")}
      confirmButtonDataTestId={TestIDs.tasks.table.menu.delete.modal.button}
    />
  );
};
